import { useState, useEffect, useCallback } from 'react';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '剧集索引', href: '#index' },
  { label: '更新速递', href: '#updates' },
  { label: '平台优势', href: '#features' },
  { label: '热播排行', href: '#ranking' },
  { label: '移动客户端', href: '#app' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 60);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMobileOpen(false);
    if (href === '#hero') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6 h-16 flex items-center justify-between">
        <a
          href="#hero"
          onClick={(e) => handleNavClick(e, '#hero')}
          className="flex items-center gap-2 cursor-pointer"
        >
          <span className="font-heading text-2xl font-bold text-primary-500 whitespace-nowrap">
            人人影视
          </span>
        </a>

        <div className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => handleNavClick(e, item.href)}
              className="px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors rounded-md hover:bg-primary-50 whitespace-nowrap cursor-pointer"
            >
              {item.label}
            </a>
          ))}
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-3 flex flex-col gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => handleNavClick(e, item.href)}
              className="px-3 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-primary-50 rounded-md transition-colors cursor-pointer"
            >
              {item.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}